// extracted by mini-css-extract-plugin
export default {"tender_form":"Certificate_tender_form__y5FxM"};